export const comment = {
    id: null,
    text: '',
}

